export default import.meta.ROLLDOWN_FILE_URL_m19jmw9K9uYTxG0jJcxFFQ